// extracted by mini-css-extract-plugin
module.exports = {"rightChat":"pFIQ8","centerChat":"_7FVIB","chatCon":"_2LYRf","loading":"_2WvAj"};